export var degreesToRadians = function degreesToRadians(degrees) {
  return Math.PI / 180 * degrees;
};